import React, { useEffect, useState, useContext } from "react";
import * as XLSX from "xlsx";
import { getCustomerTransacton, getServiceTransacton } from "../../../Utility/Api";
import { useNavigate } from "react-router-dom";
import { getFormattedCurrentDate2, NaviGate, shop_id } from "../../../Utility/function";
import { WarehouseContext } from "../../../Utility/UserContext";
import "./table.css";

const ServiceTransaction = () => {
    const navigate = useNavigate();
    const { showLoader, hideLoader } = useContext(WarehouseContext);
    const [data, setData] = useState([]);
    const [fromDate, setFromDate] = useState(getFormattedCurrentDate2());
    const [toDate, setToDate] = useState(getFormattedCurrentDate2());
    const [searchText, setSearchText] = useState("");
    const [selectedCustomer, setSelectedCustomer] = useState("");
    const [payement, setPayement] = useState("");

    useEffect(() => {
        fetchData();
    }, [fromDate, toDate, payement]);

    const fetchData = async () => {
        try {
            showLoader();
            let filter = `from_date=${fromDate}&to_date=${toDate}&shop_id=${shop_id}`;
            const response = await getServiceTransacton(filter);

            if (response.data && response.data.data) {
                let fetchedData = response.data.data;

                console.log("Fetched Data Before Mapping:", fetchedData);

                fetchedData = fetchedData.map(item => ({
                    ...item,
                    mop:
                        item.mop === "1" ? "Cash" :
                            item.mop === "2" ? "Credit" :
                                item.mop === "4" ? "Card" : "Unknown"
                }));

                console.log("Data After MOP Mapping:", fetchedData);
                console.log("Selected Payment Type:", payement);

                if (payement === "paid") {
                    fetchedData = fetchedData.filter(item => item.mop === "Cash" || item.mop === "Card");
                } else if (payement === "unpaid") {
                    fetchedData = fetchedData.filter(item => item.mop === "Credit");
                }

                console.log("Filtered Data:", fetchedData);

                setData(fetchedData);
            } else {
                setData([]);
            }

            hideLoader();
        } catch (error) {
            hideLoader();
            console.error("Error fetching order data:", error);
        }
    };

    const handleSelectCustomer = (event) => {
        setSelectedCustomer(event.target.value);
    };

    const filteredData = selectedCustomer
        ? data.filter((cus) => cus.customer_id === selectedCustomer)
        : data;

    const exportToExcel = () => {
        const exportData = filteredData
            .filter((data) => data.status != "-1")
            .map((item) => ({
                Date: item.date,
                "Service No": item.order_id,
                "Customer Name": item.customer_name,
                MOP: item.mop,
                Paid: item.mop === "Cash" || item.mop === "Card" ? item.amount : "-",
                Unpaid: item.mop === "Credit" ? item.amount : "-"
            }));

        const ws = XLSX.utils.json_to_sheet(exportData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Service_Transactions");
        XLSX.writeFile(wb, `Service_Transactions_${fromDate}_to_${toDate}.xlsx`);
    };

    return (
        <div className="page-wrappers">
            <div className="page-content py-1">
                <NaviGate />

                <form onSubmit={(e) => { e.preventDefault(); fetchData(); }} className="card p-4 shadow-sm">
                    <div className="row g-3 justify-content-end">
                        <h5 className="text-uppercase">Service Transaction</h5>

                        <div className="col-md-3 position-relative">
                            <div className="form-floating">
                                <select
                                    className="form-control"
                                    value={payement}
                                    onChange={(e) => setPayement(e.target.value)}
                                >
                                    <option value="">ALL</option>
                                    <option value="paid">Paid </option>
                                    <option value="unpaid">Unpaid</option>
                                </select>
                                <label>Select Payment</label>
                            </div>
                        </div>

                        {/* Customer Selection */}
                        <div className="col-md-3 position-relative">
                            <div className="form-floating">
                                <select
                                    className="form-control"
                                    value={selectedCustomer || ""}
                                    onChange={handleSelectCustomer}
                                >
                                    <option value="">All Customer</option>
                                    {[...new Set(data
                                        .map((customer) => customer.customer_id).filter(Boolean))]
                                        .map((customer, index) => (
                                            <option key={index} value={customer}>
                                                {data.find((dd) => dd.customer_id == customer)?.customer_name}
                                            </option>
                                        ))}
                                </select>
                                <label>Select Customer</label>
                            </div>
                        </div>

                        {/* From Date */}
                        <div className="col-md-2">
                            <div className="form-floating">
                                <input
                                    type="date"
                                    className="form-control"
                                    id="fromDate"
                                    value={fromDate}
                                    max={toDate}
                                    onChange={(e) => setFromDate(e.target.value)}
                                />
                                <label htmlFor="fromDate">From Date</label>
                            </div>
                        </div>

                        {/* To Date */}
                        <div className="col-md-2">
                            <div className="form-floating">
                                <input
                                    type="date"
                                    className="form-control"
                                    id="toDate"
                                    value={toDate}
                                    min={fromDate}
                                    onChange={(e) => setToDate(e.target.value)}
                                />
                                <label htmlFor="toDate">To Date</label>
                            </div>
                        </div>

                        <div className="col-md-2">
                            <button type="button" className="btn btn-success fw-semibold p-3 w-100" onClick={exportToExcel}>
                                Export to Excel
                            </button>
                        </div>
                    </div>

                    {/* Table */}
                    <div className="table-responsive text-center  my-2 w-100 position-relative">
                        <table className="table table-sm   table-bordered">
                            <thead className="table-dark">
                                <tr>
                                    <th>S.No</th>
                                    <th>Date</th>
                                    <th>Service NO</th>
                                    <th>Customer Name</th>
                                    <th>MOP</th>
                                    <th>Paid</th>
                                    <th>UnPaid</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredData.length > 0 ? (
                                    <>
                                        {filteredData
                                            .filter((data) => data.status != "-1")
                                            .map((item, index) => (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{item.date}</td>
                                                    <td>{item.order_id}</td>
                                                    <td>{item.customer_name}</td>
                                                    <td>{item.mop}</td>
                                                    <td className="text-success fw-bold">{item.mop === "Cash" || item.mop === "Card" ? item.amount : "-"}</td>
                                                    <td className="text-danger fw-bold">{item.mop === "Credit" ? item.amount : "-"}</td>
                                                </tr>
                                            ))}

                                        <tr className="table-primary">
                                            <td colSpan={5}></td>
                                            <td className="text-success fw-bold">{filteredData?.filter((f) => f.mop === "Cash" || f.mop === "Card").reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0).toFixed(3)}</td>
                                            <td className="text-danger fw-bold">{filteredData?.filter((f) => f.mop == "Credit" && f.status != "-1").reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0).toFixed(3)}</td>
                                        </tr>
                                    </>
                                ) : (
                                    <tr>
                                        <td colSpan="7">No data available</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </form>

            </div>
        </div>
    );
};

export default ServiceTransaction;